import { isEmpty } from 'lodash';

/**
 * 数组转object
 * @param arr
 * @param key
 * @returns
 */
export function arrToObject(arr: any[], key: string): any {
  return Object.assign({}, ...arr.map(item => ({ [item[key]]: item })));
}

/**
 * 移除对象的空属性
 * @param obj 需要过滤空属性的对象
 * @returns
 */
export function removeEmpty(obj: Record<string, any>) {
  return Object.keys(obj)
    .filter((key) => {
      if (Array.isArray(obj[key]) && obj[key].length === 0) {
        return false;
      }
      return ![undefined, null, ''].includes(obj[key]);
    })
    .reduce((a, k) => ({ ...a, [k]: obj[k] }), {});
}

type ITransType = 'snake' | 'camel';

/**
 * 下划线转驼峰
 * snake_case 转 camelCase
 * @param camel
 * @returns string
 */
function snakeToCamel(snake: string) {
  if (/^_/.test(snake)) {
    return snake;
  }
  return snake.replace(/_(\w)/g, l => l.slice(1).toUpperCase());
}

/**
 * 驼峰转下划线
 * camelCase 转 snake_case
 * @param camel
 * @returns string
 */
function camelToSnake(camel: string) {
  return camel.replace(/([A-Z])/g, '_$1').toLowerCase();
}

const transformMap = {
  camel: snakeToCamel,
  snake: camelToSnake,
};

/**
 * 方法装饰器
 * @param tranType ITransType 转换函数
 * @returns
 */
export function transformObjectDeep<T>(
  objValue: any,
  transType: ITransType,
  stayEmptyValue?: boolean,
): T {
  if (!objValue) {
    return objValue;
  }

  // 装饰器工厂函数
  const transFun = transformMap[transType];
  const oldValue = stayEmptyValue ? objValue : deleteEmptyObject(objValue);
  const newValue: any = {};
  Object.keys(oldValue)?.forEach((key) => {
    if (transType === 'camel') {
      if (key === 'material_map') {
        newValue.materialMap = oldValue[key];
        return;
      }
    } else {
      if (key === 'materialMap') {
        newValue.material_map = oldValue[key];
        return;
      }
    }
    const newKey = transFun(key);
    const tmpValue = oldValue[key];
    if (isEmpty(tmpValue) || typeof tmpValue !== 'object') {
      newValue[newKey] = tmpValue;
    } else if (Array.isArray(tmpValue)) {
      newValue[newKey] = tmpValue.map((item) => {
        if (typeof item === 'object') {
          return transformObjectDeep(item, transType, stayEmptyValue);
        }
        return item;
      });
    } else {
      newValue[newKey] = transformObjectDeep(
        tmpValue,
        transType,
        stayEmptyValue,
      );
    }
  });
  return newValue;
}

export function deleteEmptyObject(data: { [key: string]: any }) {
  const temp = { ...data };
  for (const key of Object.keys(temp)) {
    if (key === 'botPromptList') continue;
    if (typeof temp[key] === 'object' && isEmpty(Object(temp[key]))) {
      delete temp[key];
    }
    if (temp[key] === '' || temp[key] === undefined) {
      delete temp[key];
    }
  }
  return temp;
}

/**
 * 向form中传入类型为object的字段
 * @param value
 * @returns
 */
export function setObjectToField(value: Object) {
  let res = '';
  try {
    res = JSON.stringify(value);
  } catch (error) {}
  return res;
}

/**
 * form中解析value
 */
export function getObjectFromForm(value: string | Object) {
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch (error) {}
  }
  return value;
}
